import { Menu } from '@mantine/core';
import * as icons from '@sloyd/icons';
import { Button } from '../Button/Button';
import { Wrapper } from './SupportButton.style';

export type SupportButtonProps = {
  onNavigate: (path: string) => void;
};

export function SupportButton(props: SupportButtonProps) {
  return (
    <Wrapper className='SupportButton-wrapper' data-testid='SupportButton-wrapper'>
      <Menu
        transitionProps={{ transition: 'pop-top-right' }}
        position='top-end'
        width={220}
        withinPortal
      >
        <Menu.Target>
          <Button
            variant='subtle'
            rightSection={<icons.IconChevronUp size={18} stroke={1.5} />}
            pr={12}
          >
            Support
          </Button>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item
            leftSection={<icons.IconBrandDiscord />}
            onClick={() =>
              props.onNavigate('https://discord.com/channels/821659934713708555/828366615082172436')
            }
          >
            Faq
          </Menu.Item>
          <Menu.Item
            leftSection={<icons.IconBrandDiscord />}
            onClick={() =>
              props.onNavigate('https://discord.com/channels/821659934713708555/946359043977519114')
            }
          >
            Feedback and Bugs
          </Menu.Item>
          <Menu.Item
            leftSection={<icons.IconBrandDiscord />}
            onClick={() =>
              props.onNavigate(
                'https://discord.com/channels/821659934713708555/1034104979696390255'
              )
            }
          >
            Generator Ideas
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default SupportButton;
